import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment.dev";
import { IFile, IOrganization, IUser } from "../../@core/models/model";
import { BaseService } from "../../@core/services/base.service";
import { KNOWLEDGE_SCOPE } from "../models/contract-management.model";


export enum KNOWLEDGE_BASE_STORE_STATUS {
    READY = 'READY',
    UPLOADING = 'UPLOADING',
}

export interface IKnowledgeBaseStore {
    readonly _id: string;
    name: string;
    description: string,
    files: {
        file: IFile;
        numberOfTimesUsed: number,
        createdBy: IUser;
        uploadedAt: Date;
    }[];
    organization: IOrganization;
    createdBy: IUser;
    status: KNOWLEDGE_BASE_STORE_STATUS;
    size: number;
    createdAt?: Date;
    updatedAt?: Date;
}

@Injectable({ providedIn: 'root' })
export class KnowledgeBaseService extends BaseService {

    constructor(
        protected override http: HttpClient
    ) {
        super(http);
    }

    apiUrl = environment.apiUrl + '/knowledgebase';

    getKnowledgeBaseStore(filters?: { search?: string, skip?: number, limit?: number, project?: string, scope: KNOWLEDGE_SCOPE }) {
        return this.get<{ stores: IKnowledgeBaseStore[], total: number }>(this.apiUrl, filters);
    }

    getKnowledgeBaseStoreById(id: string) {
        return this.get<IKnowledgeBaseStore>(this.apiUrl + '/' + id);
    }

    createKnowledgeBaseStore(formData: FormData) {
        return this.post<IKnowledgeBaseStore>(this.apiUrl + '/', formData);
    }

    uploadFile(file: File) {
        const formData = new FormData();
        formData.append('file', file);
        return this.post(this.apiUrl, formData);
    }

    updateKnowledgeBaseStore(id: string, data: Partial<IKnowledgeBaseStore>) {
        return this.put<IKnowledgeBaseStore>(this.apiUrl + '/' + id, data);
    }


    delinkFiles(fileIds: string[], storeId: string) {
        return this.post(this.apiUrl + '/delink-files/' + storeId, { fileIds });
    }


    deleteKnowledgeBaseStore(id: string) {
        return this.delete(this.apiUrl + '/' + id);
    }

    deleteFilesFromRepo(fileIds: string[], storeId?: string) {
        return this.delete(this.apiUrl + '/file', { fileIds, storeId });
    }

}
